import "./component-library123.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "Badge",
  props: {
    // Font size
    defaultFontSize: { type: [String, Number], default: null },
    mobileFontSize: { type: [String, Number], default: null },
    disableMinContent: { type: Boolean },
    // Position
    positionDefault: { type: Object, default: () => {
    } },
    positionMobile: { type: Object, default: () => {
    } },
    // Color-theme
    magenta: { type: Boolean, default: false },
    black: { type: Boolean, default: false },
    white: { type: Boolean, default: false },
    bold: { type: Boolean, default: false }
  },
  computed: {
    styles() {
      const variables = [];
      if (this.positionMobile) {
        variables.push(this.getPositions(this.positionMobile, "xs"));
      }
      if (this.positionDefault) {
        variables.push(this.getPositions(this.positionDefault, "sm"));
      }
      if (this.mobileFontSize) {
        variables.push(this.getFontSize(this.mobileFontSize, "xs"));
      }
      if (this.defaultFontSize) {
        variables.push(this.getFontSize(this.defaultFontSize, "sm"));
      }
      return variables.join(" ").trim();
    },
    containerClasses() {
      const classNames = [];
      if (this.bold)
        classNames.push("badge--bold");
      if (this.magenta)
        classNames.push("badge--magenta");
      else if (this.black)
        classNames.push("badge--black");
      else if (this.white)
        classNames.push("badge--white");
      if (!this.disableMinContent)
        classNames.push("badge--min-content");
      return classNames.join(" ");
    }
  },
  methods: {
    getPositions(params, breakpoint) {
      const variables = [];
      ["top", "right", "bottom", "left"].forEach((property) => {
        const cssValue = params[property];
        if (!cssValue && cssValue !== 0) {
          return;
        }
        if (Number.isNaN(Number(cssValue))) {
          variables.push(`--badge-${breakpoint}-${property}: ${cssValue};`);
          return;
        }
        variables.push(`--badge-${breakpoint}-${property}: ${cssValue}px;`);
      });
      return variables.join(" ");
    },
    getFontSize(size, breakpoint) {
      if (isNaN(size)) {
        return `--badge-${breakpoint}-size: ${size};`;
      }
      return `--badge-${breakpoint}-size: ${size}px;`;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "badge", class: _vm.containerClasses, style: _vm.styles }, [_c("div", { staticClass: "badge__content" }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "3dc045bd",
  null,
  null
);
const Badge = __component__.exports;
export {
  Badge as default
};
